import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderSlot as _renderSlot, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "m-2 text-xs text-right" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Owner: ", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Groups: ", -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row flex-wrap"
}
const _hoisted_5 = { class: "flex flex-col items-start" }
const _hoisted_6 = { class: "flex flex-col items-start" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "px-2 text-xs" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "Warning: "),
  /*#__PURE__*/_createTextVNode("changing the Project will reset some Game parameters:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Current shuffle order, current Mastery set ")
], -1 /* HOISTED */)
const _hoisted_8 = {
  key: 0,
  class: "px-2 text-xs"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "User has no Location/Kindergarten selected", -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "flex flex-col items-start mt-4 p-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Progress Control", -1 /* HOISTED */)
const _hoisted_13 = { class: "flex flex-col items-start mt-4 p-1 flex-grow border" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "uppercase text-gray-550 text-sm" }, "Players", -1 /* HOISTED */)
const _hoisted_16 = { class: "flex-grow" }
const _hoisted_17 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Remove")
const _hoisted_19 = {
  key: 0,
  class: "flex flex-row justify-end mb-2"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "p-2 text-xs" }, "Maximum of 4 players are allowed", -1 /* HOISTED */)
const _hoisted_21 = {
  key: 1,
  class: "flex flex-row flex-wrap justify-end"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Save Game")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Delete Game")
const _hoisted_24 = {
  key: 2,
  class: "flex flex-row w-full items-center justify-between p-1"
}
const _hoisted_25 = { class: "flex flex-col w-full" }
const _hoisted_26 = { class: "flex flex-row justify-around" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { style: {"color":"grey"} }, "unknown", -1 /* HOISTED */)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "flex flex-col justify-start w-full text-xs p-4" }
const _hoisted_32 = { class: "mr-2" }
const _hoisted_33 = { class: "mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col rounded", [$setup.showSave ? 'bg-green-200' : 'bg-blue-200']]),
    onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.selectGame()))
  }, [
    _createElementVNode("p", _hoisted_1, [
      _hoisted_2,
      _createTextVNode(_toDisplayString($setup.ownerName) + " ", 1 /* TEXT */),
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.gameGroups, (gg) => {
        return (_openBlock(), _createElementBlock("span", {
          key: gg._id
        }, _toDisplayString(gg.name), 1 /* TEXT */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    ($props.edit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode($setup["AnswerInput"], {
              modelValue: $setup.theGame.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.theGame.name) = $event)),
              class: "m-2",
              mode: "text",
              label: "Name",
              border: false,
              onChange: $setup.saveActive
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode($setup["SelectionBox"], {
              id: "select-project",
              modelValue: $setup.currentProjectName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.currentProjectName) = $event)),
              class: "m-2",
              label: 'Set a Project..',
              options: $setup.projectOptionList,
              "reset-on-choose": false,
              onChange: $setup.setProject
            }, null, 8 /* PROPS */, ["modelValue", "label", "options"]),
            _hoisted_7,
            _createVNode($setup["AnswerInput"], {
              "boolean-value": $setup.theGame.project.shuffleTopLevel,
              "onUpdate:boolean-value": _cache[2] || (_cache[2] = ($event: any) => (($setup.theGame.project.shuffleTopLevel) = $event)),
              class: "m-2 mt-4",
              mode: "binaryChoice",
              border: false,
              label: "Shuffle top-level items (weeks)",
              description: "Shuffle the Game's weeks upon first entry",
              onChange: $setup.saveActive
            }, null, 8 /* PROPS */, ["boolean-value"]),
            _createVNode($setup["AnswerInput"], {
              "multi-choice-value": $setup.theGame.sharing.groups,
              "onUpdate:multi-choice-value": _cache[3] || (_cache[3] = ($event: any) => (($setup.theGame.sharing.groups) = $event)),
              label: "Sharing",
              description: "Sets of Users (e.g. kindergartens) who can see this Game",
              mode: "multiChoice",
              options: $setup.usersGroups,
              underline: false,
              class: "m-2",
              onChange: $setup.saveActive
            }, null, 8 /* PROPS */, ["multi-choice-value", "options"]),
            ($setup.usersGroups.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _hoisted_10))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode($setup["AnswerInput"], {
              "boolean-value": $setup.theGame.status.controlActive,
              "onUpdate:boolean-value": _cache[4] || (_cache[4] = ($event: any) => (($setup.theGame.status.controlActive) = $event)),
              class: "m-2 pt-2",
              mode: "binaryChoice",
              border: false,
              label: "Restrict SET progress",
              description: "Enforce progress using the Mastery monitor panel (DSLPlus)",
              onChange: $setup.saveActive
            }, null, 8 /* PROPS */, ["boolean-value"]),
            _createVNode($setup["AnswerInput"], {
              "boolean-value": $setup.theGame.status.redoTasks,
              "onUpdate:boolean-value": _cache[5] || (_cache[5] = ($event: any) => (($setup.theGame.status.redoTasks) = $event)),
              class: "m-2 pt-2",
              mode: "binaryChoice",
              border: false,
              label: "Allow access to previous tasks",
              description: "Previously completed questions can be tried again.\n          Activating this affects the meaning of a 'completed Set', as a Set\n          is normally completed immediately after the final Question",
              onChange: $setup.saveActive
            }, null, 8 /* PROPS */, ["boolean-value"]),
            _createVNode($setup["AnswerInput"], {
              "boolean-value": $setup.theGame.status.skipTasks,
              "onUpdate:boolean-value": _cache[6] || (_cache[6] = ($event: any) => (($setup.theGame.status.skipTasks) = $event)),
              class: "m-2 pt-2",
              mode: "binaryChoice",
              border: false,
              label: "Allow access to future tasks",
              description: "Future tasks beyond will be accessible even if the current task is not completed",
              onChange: $setup.saveActive
            }, null, 8 /* PROPS */, ["boolean-value"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _hoisted_15,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.addedPlayers, (p, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "flex flex-row items-center w-full"
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", null, [
                    _createTextVNode("Ref: " + _toDisplayString(p.profile.ref) + " Avatar name: " + _toDisplayString(p.profile.name) + " ", 1 /* TEXT */),
                    (p.profile.deleted)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, "INACTIVE"))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _createVNode($setup["Button"], {
                  id: `button-remove-group-${p._id}`,
                  class: "my-1 mx-2 self-end place-self-end justify-self-end",
                  childclass: 'w-32',
                  backgroundcolour: 'bg-white',
                  onVclick: ($event: any) => ($setup.removePlayer(p))
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "onVclick"])
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            ($setup.addedPlayers.length < 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode($setup["SelectionBox"], {
                    id: "select-group",
                    modelValue: $setup.currentPlayerName,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.currentPlayerName) = $event)),
                    label: 'Add a Player..',
                    options: $setup.playerOptionList,
                    "reset-on-choose": true,
                    onChange: $setup.addPlayer
                  }, null, 8 /* PROPS */, ["modelValue", "label", "options"]),
                  _hoisted_20
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($props.edit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _renderSlot(_ctx.$slots, "closeEdit"),
          _createElementVNode("div", null, [
            ($setup.showSave)
              ? (_openBlock(), _createBlock($setup["Button"], {
                  key: 0,
                  id: "button-save",
                  class: "col-start-2 my-2 mr-2",
                  backgroundcolour: 'bg-green-400',
                  onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.saveGame()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode($setup["Button"], {
              class: "col-start-2 my-2 mr-2",
              backgroundcolour: 'bg-red-600',
              textcolour: 'text-white',
              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.deleteGame()))
            }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1 /* STABLE */
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("p", null, [
                ($setup.theGame)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_27, _toDisplayString($setup.theGame.name), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("strong", _hoisted_28, _hoisted_30))
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("p", _hoisted_32, "ID: " + _toDisplayString($setup.theGame._id), 1 /* TEXT */),
              _createElementVNode("p", _hoisted_33, " Last progress sync: " + _toDisplayString($setup.formattedDate), 1 /* TEXT */)
            ])
          ]),
          _renderSlot(_ctx.$slots, "default")
        ]))
  ], 2 /* CLASS */))
}